import { ChatMode } from "../enums/ChatMode";
import IBotService from "../interfaces/IBotService";
import BotStartMessage from "../models/BotStartMessage";
import { FeedbackRequest } from "../models/FeedbackRequest";
import IConversationResponse from "../models/IConversationResponse";
import IFeedbackResponse from "../models/IFeedbackResponse";
import { IResponse } from "../models/IResponse";
import PostQueryRequest from "../models/PostQueryRequest";
import { QueryResponse } from "../models/QueryResponse";


// Mock service implementation
export default class MockBotService implements IBotService {
    getConversations(chat_mode: ChatMode, offset: number, limit: number): Promise<IConversationResponse[]> {
        throw new Error("Method not implemented.");
    }
    getConversationHistory(conversation_id: string, chat_mode: ChatMode): Promise<QueryResponse> {
        throw new Error("Method not implemented.");
    }
    public async getBotStartMessage(chat_mode: string): Promise<BotStartMessage> {
        return {
            Message: "Hi there! 👋 Welcome to financial peer review bot, your assistant for quick answers and helpful insights. To get started, you can select a suggested prompt below or type your own query!",
            Suggestions: [
                {
                    name: "Compare quarter results",
                    prompt: "Get all metrics related to latest quarter result for all companies.. Show NA if answer is not available for any metric."
                },
                {
                    name: "Company with highest revenue growth",
                    prompt: "Which company has the highest revenue growth in the latest quarter?"
                },
                {
                    name: "Compare adjusted operating income",
                    prompt: "Compare the adjusted operating income of all the companies of latest quarter result."
                },
                {
                    name: "Compare quarter results",
                    prompt: "Get all metrics related to latest quarter result for all companies.. Show NA if answer is not available for any metric."
                },
                {
                    name: "Company with highest revenue growth",
                    prompt: "Which company has the highest revenue growth in the latest quarter?"
                },
                {
                    name: "Compare adjusted operating income",
                    prompt: "Compare the adjusted operating income of all the companies of latest quarter result."
                }
            ]
        };
    }

    public async createBotStartMessage(data: BotStartMessage): Promise<BotStartMessage> {
        return data;
    }


    public async postQuery(data: PostQueryRequest): Promise<IResponse> {
        return {
            message_id: "80FC8F26-EADA-4F89-87B7-F6530C0BD88F",
            conversation_id: "ED3C0AA0-59A0-4267-B3A9-0B452188B170",
            sender: "assistant",
            content: {
                Answer: "Aon's revenue for the three months ended September 30, 2024, was $3.721 billion, and for the nine months ended September 30, 2024, it was $11.551 billion.",
                Citations: [
                    "https://wtwonline.sharepoint.com/sites/intranetdevelopers_en/KnwoledgeStore/Aon-3Q24.pdf"
                ]
            }
        };
    }



    public async postFeedback(data: FeedbackRequest): Promise<IFeedbackResponse> {
        let Test: IFeedbackResponse;
        Test = {
            conversation_id: "1",
            message_id: "2"
        };
        return Test;
    }
}